export default {
    users: {
        title: 'Пользователи',
        subtitle: 'Раздел пользователи',
        user: 'Пользователи',
    },
}
